import { PayloadAction } from '@reduxjs/toolkit';

import { IUserInitial } from './user.slice';
import { AuthService } from '@shared/lib/services';

export const actions = {
  logout: (state: IUserInitial) => {
    state.isAuth = false;
    state.userId = '';
    state.accessToken = '';
    state.refreshToken = '';

    AuthService.clearStorage();
  },
  setCredentials: (
    state: IUserInitial,
    { payload }: PayloadAction<{ userId: string; accessToken: string; refreshToken: string }>
  ) => {
    state.isAuth = true;
    state.userId = payload.userId;
    state.accessToken = payload.accessToken;
    state.refreshToken = payload.refreshToken;
  },
};
